import React from 'react';
import { Heading } from 'native-base';

export function Example() {
  return <Heading fontSize="5xl">Hh</Heading>;
}
